import { ResourceProps } from "react-admin";
import { PaymentShow, PaymentsList } from "./components";

export const userPurchasesResource: Omit<ResourceProps, "name"> = {
  list: PaymentsList,
  show: PaymentShow,
};

export { PaymentsTab } from "./components";
